export default __webpack_public_path__ + "static/media/Error.ffe2935f.svg";